import { PointInTime, pointInTimeToDate } from '../dateHelpers';

export const minMaxDate = (
  [date, message, offset = 0]: [string | undefined, string] | [string | undefined, string, number | string],
  isMin: boolean
): [string | Date, string] => [pointInTimeToDate(date as PointInTime, offset, isMin) ?? '', message];
